import React from 'react';
import { connect } from 'react-redux';
import { initApp } from './actions/environmentActions';
import Modal from './Components/Modal';
import Spinner from './Components/Spinner';

class Unauthorized extends React.Component {
       
    componentDidMount(){
        // /this.props.initApp(false);
    }

    render() {

        const { isFetching } = this.props

        return (

            <div className="bg-unauth" style={{minHeight: 750}}>
                {isFetching && (
                    <Spinner color="#ffffff" />
                )}

                {!isFetching && (
                    <div className="app-children" style={{marginTop:65}}>
                        {this.props.children}
                    </div>
                )}

             <Modal />
          </div>
        )
    }
}

function mapStateToProps(state) {
  
  const {  isFetching } = state.thisApp.environment
  
  return {
     isFetching
  }
}

export default connect(mapStateToProps)(Unauthorized);


// WEBPACK FOOTER //
// ./src/Unauthorized.js